import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';

function ProtectedRoute({ children }) {
  const { userInfo } = useUser();

  if (!userInfo) {
    // 로그인이 되어 있지 않으면 로그인 페이지로 리다이렉트
    return <Navigate to="/" replace />;
  }

  // 로그인이 되어 있으면 자식 컴포넌트 렌더링
  return children;
}

export default ProtectedRoute;